<form (submit)="onFormSubmit($event)">
  <dx-form id="form"
           [formData]="field"
           [showValidationSummary]="true"
           (onFieldDataChanged)="addFormChange($event)">

    <dxi-item itemType="group" colSpan="2" colCount="2">
      <dxi-item dataField="code">
        <dxo-label text="Code"></dxo-label>
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxi-validation-rule type="async" message="Code existe déjà"
                             [validationCallback]="codeValidation"></dxi-validation-rule>
      </dxi-item>
      <dxi-item dataField="name">
        <dxo-label text="Nom"></dxo-label>
        <dxi-validation-rule type="required" message="Le nom est obligatoire"></dxi-validation-rule>
        <dxi-validation-rule type="stringLength" [min]="3" [max]="100"></dxi-validation-rule>
      </dxi-item>
    </dxi-item>
    <dxi-item itemType="group" colSpan="2" colCount="2">
      <dxi-item dataField="domain_id">
        <dxo-label text="Domaine"></dxo-label>
        <div *dxTemplate>
          <app-user-domains-chooser (valueChange)="domainChange($event)"
                                    [id]="field.domain_id"></app-user-domains-chooser>
        </div>
      </dxi-item>
      <dxi-item dataField="cadastral_area" editorType="dxNumberBox" [editorOptions]="{format: '#0.## Ha'}">
        <dxo-label text="Superficie Cadastrale"></dxo-label>
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>
    </dxi-item>
    <dxi-item itemType="group" colSpan="2" colCount="2">
      <dxi-item dataField="color" editorType="dxColorBox">
        <dxo-label text="Couleur"></dxo-label>
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>
      <dxi-item dataField="is_irrigated" editorType="dxSwitch">
        <dxo-label text="Irriguée?"></dxo-label>
      </dxi-item>
    </dxi-item>
    <dxi-item
      itemType="button"
      horizontalAlignment="right"
      [buttonOptions]="buttonOptions">
    </dxi-item>
  </dx-form>
</form>
